import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import { FORMAL_NAV_BAR_INFO } from './FormalNavBarConsts';
import { TABLET_WIDTH } from '../../elements/Const';
import ScrollLock from '../../elements/ScrollLock';
import logoSVG from '../../elements/static/logo.svg';
import { inDev, startedFlash } from '../../Utils';
import { FLASH_EVENT } from '../../Const';

const StyledMenu = styled.div`
  display: none;
  letter-spacing: 1px;
  font-size: 0.9rem;

  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (max-width: ${TABLET_WIDTH}) {
    width: 45%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgb(17, 60, 113, 0.98);
    height: 100vh;
    text-align: left;
    padding: 5rem 0 2rem;
    position: absolute;
    top: 0;
    left: 0;
    transition: transform 0.4s ease-in-out;
    z-index: 10;
    box-shadow: 2px 0px 15px 0 rgba(0, 0, 0, 0.5);
    transform: ${(props) => (props.opened === 'opened' ? 'translateX(0)' : 'translateX(-150%)')};

    .logo {
      display: flex;
      flex-direction: column;
      align-items: center;
      border-bottom: 1px solid rgb(255, 255, 255, 0.3);
      padding: 0 1.5rem;
      margin-bottom: 1.5rem;
      &--pic {
        width: 2.5rem;
        &:hover {
          opacity: 0.8;
        }
      }
      &--text {
        color: rgb(255, 255, 255, 1);
        font-size: 1rem;
        font-weight: 600;
        letter-spacing: 3px;
        margin: 0.8rem 0;
        &:hover {
          opacity: 0.8;
        }
      }
    }

    .link-btn {
      display: block;
      position: relative;
      color: rgb(255, 255, 255, 1);
      border-bottom: 4px solid white;
      border-color: transparent;
      padding: 0.25rem 0rem;
      text-align: center;
      margin-bottom: 1rem;

      .list-toggle {
        background: none;
        border: none;
        padding: 0;
        color: inherit;
        font: inherit;
        letter-spacing: inherit;
        cursor: pointer;
      }

      .link-list {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        margin: 0.5rem 0;
        .link-btn {
          margin: 0;
        }
      }

      &:hover {
        cursor: pointer;
        border-color: #25eeff;
      }
    }
  }
`;

const NavItem = ({ itemKey }) => {
  const info = FORMAL_NAV_BAR_INFO[itemKey];
  const [isOpen, setIsOpen] = useState(false);

  if (!info.links?.length) {
    return (
      <a className="link-btn" href={info.url}>
        {info.text}
      </a>
    );
  }

  return (
    <div className="link-btn list-btn">
      <button type="button" className="list-toggle" aria-expanded={isOpen} onClick={() => setIsOpen(!isOpen)}>
        {info.text} <span aria-hidden="true">{isOpen ? '▾' : '▸'}</span>
      </button>
      {isOpen && (
        <div className="link-list">
          {info.links.map((link) => (
            <a
              key={link.url}
              className="link-btn"
              href={link.url}
              {...(link.isExternal ? { target: '_blank', rel: 'noreferrer noopenner' } : {})}
            >
              {link.text}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

const HamburgerMenu = ({ isHambugerOpen, isLogin, userInfo = {}, hideItems = false, current = {} }) => {
  return (
    <StyledMenu opened={isHambugerOpen ? 'opened' : 'closed'}>
      {isHambugerOpen && <ScrollLock />}
      <a className="logo" href={FORMAL_NAV_BAR_INFO.LOGO.url}>
        <img className="logo--pic" src={logoSVG?.src ?? logoSVG} alt="" />
        <div className="logo--text"> {FORMAL_NAV_BAR_INFO.LOGO.text} </div>
      </a>
      {current?.url && (
        <a className="link-btn" href={current.url}>
          {current.text}
        </a>
      )}
      {!hideItems &&
        [
          'NEWBIE',
          'PROSPECT',
          'ENT',
          'GAME',
          'LEADERBOARD',
          'ROSTER_RESOURCES',
          'BLOG',
          'NEW_STATS',
          'TOOL',
          'MEMBER',
        ].map((itemKey) => <NavItem key={itemKey} itemKey={itemKey} />)}
      {isLogin ? (
        <Fragment>
          <a className="link-btn" href={FORMAL_NAV_BAR_INFO.ACCOUNT_MANAGEMENT.url}>
            {FORMAL_NAV_BAR_INFO.ACCOUNT_MANAGEMENT.text}
          </a>
          {userInfo.isAdmin === 'ADMIN' && (
            <a className="link-btn" href={FORMAL_NAV_BAR_INFO.MEMBER_MANAGEMENT.url}>
              {FORMAL_NAV_BAR_INFO.MEMBER_MANAGEMENT.text}
            </a>
          )}
          <a className="link-btn" href={FORMAL_NAV_BAR_INFO.LOG_OUT.url}>
            {FORMAL_NAV_BAR_INFO.LOG_OUT.text}
          </a>
        </Fragment>
      ) : (
        <Fragment>
          <a className="link-btn" href={FORMAL_NAV_BAR_INFO.LOG_IN.url}>
            {FORMAL_NAV_BAR_INFO.LOG_IN.text}
          </a>
        </Fragment>
      )}
    </StyledMenu>
  );
};

export default HamburgerMenu;
